"use client";
import { jsxs as v, jsx as i } from "react/jsx-runtime";
import x from "../../common/components/input-meta/InputMeta.js";
import D from "../../common/components/label/Label.js";
import { InputFieldWrapper as N } from "../../common/styles/components/InputFieldWrapper.js";
import { SELECT_LIST_SIZES as j, SELECT_ITEM_SIZES as w } from "./selectCommonTypes.js";
import u from "./SelectField.js";
import { useFeId as C } from "../../hooks/useFeId.js";
const E = ({
  "aria-errormessage": a,
  className: I,
  defaultValue: n,
  disabled: m,
  feHideLabel: L,
  feHint: e,
  feLabel: $,
  feRows: c,
  feRequiredText: F,
  feSeverity: r,
  feSize: t = "md",
  id: o = C(),
  multiple: S,
  onChange: p,
  required: s,
  value: d,
  ...g
}) => {
  const T = t === "sm" ? "sm" : "md", _ = Number(String(j.padding).replace(/\D+$/g, "")) * 16 * 2, b = Number(String(w[T]).replace(/\D+$/g, "")) * 16, h = c ? c * b + _ : void 0, l = e && r === "error" ? `${o}-hint` : void 0;
  return /* @__PURE__ */ v(N, { className: I, "data-comp": "select", feSize: t, children: [
    /* @__PURE__ */ i(
      D,
      {
        feDisabled: m,
        feHideLabel: L,
        feRequired: s,
        feRequiredText: F,
        feSize: t,
        htmlFor: o,
        id: o ? `${o}-label` : void 0,
        onClick: () => window.dispatchEvent(new Event("resize")),
        children: $
      }
    ),
    S ? /* @__PURE__ */ i(
      u,
      {
        ...g,
        "aria-errormessage": l ?? a,
        "aria-invalid": r === "error" ? !0 : void 0,
        defaultValue: n,
        disabled: m,
        feListHeight: h,
        feSeverity: r,
        feSize: t,
        id: o,
        multiple: !0,
        onChange: p,
        required: s,
        value: d
      }
    ) : /* @__PURE__ */ i(
      u,
      {
        ...g,
        "aria-errormessage": l ?? a,
        "aria-invalid": r === "error" ? !0 : void 0,
        defaultValue: n,
        disabled: m,
        feListHeight: h,
        feSeverity: r,
        feSize: t,
        id: o,
        multiple: !1,
        onChange: p,
        required: s,
        value: d
      }
    ),
    e && /* @__PURE__ */ i(x, { feSeverity: r, feSize: t, id: l, children: e })
  ] });
};
E.displayName = "Select";
const B = E;
export {
  B as default
};
